/**
 * 「キーを 1 つ入れるだけの小さな画面」の日本語（en.enterKey.ts と同じキーを全部持つ。漏れは typecheck で落ちる）。
 * 2026-10-04 creator/chat-secrets。言葉の決め事は en.enterKey.ts の冒頭と同じ:
 *   API・シークレット・秘密鍵・環境・本番・開発・デプロイ・トークン・リクエストと書かない。日本のふつうのアプリの言い方で、短く。
 *   どちらで使うか = 「公開中のアプリ（本物の URL）/ テスト用のアプリ（本物の URL）」（founder 2026-10-04「抽象的な言葉にしない」・管理の決まり）。保存したら「チャットに戻ってください」（founder の言い方そのまま）
 */
import type { enEnterKey } from './en.enterKey';

type EnterKeyMessages = { [K in keyof typeof enEnterKey]: string };

export const jaEnterKey: EnterKeyMessages = {
  'enterKey.title': 'キーを貼り付け',
  'enterKey.titleFor': '{service} のキーを貼ってください',
  'enterKey.titleNamed': '{name} を貼ってください',
  'enterKey.lead': '下の欄に貼って、「保存する」を押してください。',
  'enterKey.where.production': '公開中のアプリ（{url}）で使います。',
  'enterKey.where.development': 'テスト用のアプリ（{url}）で使います。',
  'enterKey.where.productionNoUrl': '公開中のアプリで使います。',
  'enterKey.where.developmentNoUrl': 'テスト用のアプリで使います。',
  'enterKey.label': 'キー',
  'enterKey.placeholder': 'ここに貼り付け',
  'enterKey.safe': 'ここに貼ったものは AI には見えません。会話にも残りません。',
  'enterKey.nameNote': '{name} という名前で保存します（AI が決めた名前です）。',
  'enterKey.save': '保存する',
  'enterKey.empty': '先にキーを貼り付けてください。',
  'enterKey.tooLong': '長すぎます（5 KB まで）。キーだけをコピーしたか確かめてください。',
  'enterKey.confirmTitle': '公開中のアプリに保存しますか？',
  'enterKey.confirmBody': '公開中のアプリをいま使っている人にも、すぐにこのキーが使われます。',
  'enterKey.confirmButton': '保存する',
  'enterKey.doneTitle': '保存しました',
  'enterKey.doneBody': 'チャットに戻ってください。このページは閉じてかまいません。',
  'enterKey.again': 'もう一度入れる',
  'enterKey.badLink': 'リンクが正しくありません。AI にもう一度ページを開いてもらってください。',
  'enterKey.error.notReady': 'まだ使えません。AI に「サーバーを公開して」と頼んでから、もう一度このページを開いてください。',
  'enterKey.error.stopped': 'いまは止まっています。AI に「動かして」と頼んでから、もう一度このページを開いてください。',
  'enterKey.error.rateLimited': '短い間に何度も保存しています。{seconds} 秒ほど待ってから、もう一度お試しください。'
};
